import { useMemo } from 'react';
import { round } from 'lodash';

import { useAppSelector } from 'utils/hooks';
import { selectZoomedPPI } from 'selectors/ppi';

import canvases from 'domains/canvases';

export function useCalculatedBounds(canvasId: string, nodeUid: string) {
  const ppi = useAppSelector(selectZoomedPPI);
  const bounds = useAppSelector((state) =>
    canvases.selectors.calculatedBoundsForCanvasNode(state, { canvasId, nodeUid })
  );

  const withPPI = useMemo(() => bounds.map((b) => round(b * ppi, 6)), [bounds, ppi]);

  return withPPI;
}
